import { httpClient } from '@/api/http-client'
import { ProfitSharePayload } from '@/types'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type Params = {
  companyKey: string
  profitShareData: ProfitSharePayload[]
}

export const useUpdateProfitShare = (
  options?: UseMutationOptions<void, AxiosError, Params>,
) => {
  const updateProfitShare = async ({
    companyKey,
    profitShareData,
  }: Params): Promise<void> => {
    const response = await httpClient('accounting-dealer').put(
      `v3/company/${companyKey}/profit-share`,
      { profit_share: profitShareData },
    )
    return response.data
  }

  return useMutation({
    mutationFn: updateProfitShare,
    ...options,
  })
}
